const validate = values => {
	const errors = {}

	if (values.common_vineyards === undefined  && values.varietal_vineyards === undefined) {
		errors.common_vineyards = 'Alguno de los campos es requerido para continuar';
        errors.varietal_vineyards = 'Alguno de los campos es requerido para continuar';
	}

	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsVineyardTypesForm.js
 **/